export const asyncWrapper =
  (handler) =>
  (...args) => {
    return handler(...args).catch((error) => error);
  };

export const asyncWrapperForSessionManage = (handler) => (payload) => {
  return handler(payload).catch((error) => error);
};
